// src/content/homeContent.ts
import CLINIC_CONFIG from "../../config/clinicConfig";

export const HOME_META = {
  title: `${CLINIC_CONFIG.clinicName}, ${CLINIC_CONFIG.stateShortForm} | Family & Cosmetic Dental Care`,
  description: `Welcome to ${CLINIC_CONFIG.clinicName}, ${CLINIC_CONFIG.stateShortForm}. We provide affordable, compassionate family and cosmetic dental care. Accepting Medicaid, Medicare, and most insurances. Book your appointment today!`,
  keywords: `dentist ${CLINIC_CONFIG.city} ${CLINIC_CONFIG.stateShortForm}, family dentistry, cosmetic dentistry, dental implants, Medicaid dentist, Medicare dentist, affordable dental care, teeth cleaning, dental crowns, dental bridges, emergency dentist, ${CLINIC_CONFIG.city} dental clinic`,
  canonicalUrl: CLINIC_CONFIG.clinicUrl,
};

export const HOME_HERO = {
  headingLines: [
    "Get Expert General",
    "Dentistry Care in",
    CLINIC_CONFIG.clinicName,
  ],
};

export const HOME_HIDDEN_H1 = `Family & Cosmetic Dentist in ${CLINIC_CONFIG.clinicName}, ${CLINIC_CONFIG.stateShortForm}`;

export interface HomeFaqItem {
  id: string;
  question: string;
  answer: string;
}

export const HOME_FAQS: HomeFaqItem[] = [
  {
    id: "1",
    question: "Do you treat patients of all ages?",
    answer:
      "Absolutely! We are a family-friendly practice and proudly serve patients of all ages, from young children to seniors. We tailor our care to meet the unique needs of every life stage.",
  },
  {
    id: "2",
    question: "How long does a typical check-up and cleaning take?",
    answer:
      "A routine visit, which includes an exam, X-rays, and cleaning, is usually completed in about an hour. We respect your time and work efficiently to get you back to your day with a sparkling smile.",
  },
  {
    id: "3",
    question: "I'm nervous about dental visits. Will it hurt?",
    answer:
      "Your comfort is our top priority. We are committed to providing gentle, compassionate care. Most routine procedures, including cleanings and exams, are painless. If you ever feel anxious, please let us know—we have ways to help you feel at ease.",
  },
  {
    id: "4",
    question: "Can I eat or drink right after my appointment?",
    answer:
      "For a standard cleaning, yes! If you received a professional fluoride treatment, we recommend avoiding eating or drinking for at least 30 minutes. This allows the fluoride to fully absorb and provide maximum protection for your teeth.",
  },
  {
    id: "5",
    question: "How often do I really need to see the dentist?",
    answer:
      "For most patients, we recommend a visit every six months. However, your schedule is based on your unique oral health. If you are at a higher risk for cavities or gum disease, we may recommend more frequent visits to ensure your smile stays healthy.",
  },
];
